define([
	"csi/config",
	"dojo/_base/declare",
	"csi/table/New"
], function(config,declare,New) {

	return declare(New, {

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set value for season to the parent season and make it read only
			if (this.getParent() && this.getParent().$Type == "Season") {
				view.addFixedValue("ThemeSeasons", [this.m_urlParent]);
			}

			// if ThemeMaster ThemeBOMFeature is Off then hide ThemeBOMType field
			const themeBOMFeatureValue = config.getSubtypeSetting(this.getParent().Subtype, "ThemeBOMFeature");
			if (this.getParent() && themeBOMFeatureValue === "ThemeBOMFeature:Off") {
				view.setFieldDisabled("ThemeBOMType", true);
			}

			this.inherited(arguments);
		}

	});
});